import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Seo from '../components/Seo';
import HeroSection from '../components/home/HeroSection';
import ModernChallengeSection from '../components/home/ModernChallengeSection';
import FrameworkSection from '../components/home/FrameworkSection';
import AudiencesSection from '../components/home/AudiencesSection';
import ProgramsSection from '../components/home/ProgramsSection';
import SpecialistServicesSection from '../components/home/SpecialistServicesSection';
import WhyZeevaSection from '../components/home/WhyZeevaSection';
import TrustSection from '../components/home/TrustSection';
import ProgressStoriesSection from '../components/home/ProgressStoriesSection';
import BlogPreviewSection from '../components/home/BlogPreviewSection';
import AssessmentCTASection from '../components/home/AssessmentCTASection';
import ContactSection from '../components/home/ContactSection';
import FooterSection from '../components/home/FooterSection';
import WhatsAppFloat from '../components/home/WhatsAppFloat';
import { ORGANIZATION_SCHEMA } from '../lib/seo/constants';

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 150);
    return () => clearTimeout(t);
  }, [hash]);

  const scrollToSection = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen" data-testid="home-page">
      <Seo
        title="Build Strength. Preserve Mobility. Extend Vitality."
        description="ZEEVA Life — evidence-based exercise, rehabilitation, mobility and lifestyle strategies for lifelong human capability, healthspan and longevity."
        path="/"
        structuredData={ORGANIZATION_SCHEMA}
      />
      <Header />
      <main>
        <HeroSection onScrollToSection={scrollToSection} />
        <ModernChallengeSection />
        <FrameworkSection />
        <AudiencesSection />
        <ProgramsSection />
        <SpecialistServicesSection />
        <WhyZeevaSection />
        <TrustSection />
        <ProgressStoriesSection />
        <BlogPreviewSection />
        <AssessmentCTASection onScrollToSection={scrollToSection} />
        <ContactSection />
      </main>
      <FooterSection onScrollToSection={scrollToSection} />
      <WhatsAppFloat />
    </div>
  );
};

export default Home;
